module.exports = __webpack_public_path__ + "img/st-3.2d412e48.jpg";